import React from 'react';

export default function AppHeader() {
  return (
    <header>
      <div>
        <a href="https://hoshino-bespokeshoes.jp">
          <div className="logo">
            <img src="/images/logo.png" alt="logo" />
          </div>
        </a>
      </div>
    </header>
  );
}